/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

angular.module('prism-ui.genres').service('GenresService', function (this: JS5Object,
                                                                       GenresResourceFactory: JS5Object,
                                                                       PaginationService: JS5Object) {
    this.originalEditData;
    this.viewData;

    const responseHandler = (data: JS5Object, responseHeaders: JS5Function) => {
        PaginationService.parseResponseHeaders(responseHeaders());
        PaginationService.pageData = data;
    };

    this.getAllGenres = (criteria: JS5Object) => {
        return GenresResourceFactory.query(criteria, responseHandler).$promise;
    };
    this.createGenre = (genre: JS5Object) => {
        return GenresResourceFactory.createGenre(genre).$promise;
    };
    this.getGenre = (genreId: number) => {
        return GenresResourceFactory.getGenre({id: genreId}).$promise
    };

    this.updateGenre = (genre: JS5Object) => {
        return GenresResourceFactory.updateGenre(genre).$promise;
    };

    this.deleteGenre = (genreId: number) => {
        return GenresResourceFactory.deleteGenre({id: genreId}).$promise;
    };
});
